import React from 'react';
import mapherionImg from '../assets/mapherion.png';
import cinemorphImg from '../assets/cinemorph.png';
import stylosImg from '../assets/stylos.png';
import countrillaImg from '../assets/countrilla.png';
import veqsyImg from '../assets/veqsy.png';
import KugaValveImg from  '../assets/kugavalve.png';
import GitCheckImg from  '../assets/gitcheck.png';

function MiddleSection() {
  return (
    <div className="middle-section">
      {/* Dekoratif arka plan */}
      <div className="bg-decoration">
        <div className="glow-orb glow-orb-1"></div>
        <div className="glow-orb glow-orb-2"></div>
        <div className="noise-overlay"></div>
      </div>

      {/* İçerik */}
      <div className="content-wrapper">
        {/* Başlık */}
        <div className="section-header">
          <h2 className="section-title">projects</h2>
          <div className="title-line"></div>
        </div>

        {/* Projeler Grid */}
        <div className="projects-grid">

        <a target='_blank' rel='noreferrer' href='https://www.gitcheck.me/'>
          <div className="project-card">
            <div className="project-image">
            <img src={GitCheckImg} alt="GitCheck project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
              <div className="title-with-badge">
                  <h3 className="project-title">GitCheck</h3>                  
                </div>               
              </div>
              <p className="project-description">
              GitCheck is a comprehensive GitHub profile analyzer that transforms your code contributions into quantifiable career metrics.
              </p>
              <div className="project-tags">
                <span className="tag">Next.js</span>
                <span className="tag">TypeScript</span>
                <span className="tag">PostgreSQL</span>
                <span className="tag">NextAuth.js</span>
                <span className="tag">Tailwind CSS</span>
                <span className="tag">Framer Motion</span>
                <span className="tag">shadcn/ui</span>                                
              </div>
            </div>
          </div>
          </a>

        <a target='_blank' rel='noreferrer' href='http://kugavalve.com/'>
          <div className="project-card">
            <div className="project-image">
            <img src={KugaValveImg} alt="Kuga Valve project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
              <div className="title-with-badge">
                  <h3 className="project-title">Kuga Valve</h3>                  
                </div>               
              </div>
              <p className="project-description">
              I developed the Kuga Valve website to present products and technical information through a user-friendly interface.
              </p>
              <div className="project-tags">
                <span className="tag">HTML</span>
                <span className="tag">CSS</span>
                <span className="tag">JavaScript</span>
                <span className="tag">PHP</span>                
              </div>
            </div>
          </div>
          </a>
          {/* Proje 1 */}
          <a target='_blank' rel='noreferrer' href='https://maperion.vercel.app/'>
          <div className="project-card">
            <div className="project-image">
            <img src={mapherionImg} alt="Maperion project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
              <div className="title-with-badge">
                  <h3 className="project-title">Maperion</h3>
                  <span className="beta-badge">BETA</span>
                </div>               
              </div>
              <p className="project-description">
                Mapherion is a 2D map quiz game where you test your geography skills by finding countries on a world map.
              </p>
              <div className="project-tags">
                <span className="tag">React</span>
                <span className="tag">Design</span>
                <span className="tag">Vite</span>
                <span className="tag">Firebase</span>
                <span className="tag">SCSS</span>
              </div>
            </div>
          </div>
          </a>

          {/* Proje 2 */}
          <a target='_blank' rel='noreferrer' href='https://cinemorph-eosin.vercel.app/'>
          <div className="project-card">
            <div className="project-image">
            <img src={cinemorphImg} alt="Cinemorph project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
                <div className="title-with-badge">
                  <h3 className="project-title">Cinemorph</h3>                  
                </div>
                <a href="https://github.com/goktugkrblt/cinemorph" target="_blank" rel="noopener noreferrer" className="github-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
              </div>
              <p className="project-description">
                Cinemorph is an IMDb-inspired web app that lets users browse, search, and filter movies, providing a smooth and interactive movie discovery experience.
              </p>
              <div className="project-tags">
                <span className="tag">React</span>
                <span className="tag">React Router</span>
                <span className="tag">CSS / SCSS</span>
                <span className="tag">Axios</span>
                <span className="tag">External API</span>
              </div>
            </div>
          </div>
          </a>
          {/* Proje 3 */}
          <a target='_blank' rel='noreferrer' href='https://stylos-nine.vercel.app/'>
          <div className="project-card">
            <div className="project-image">
            <img src={stylosImg} alt="Stylos project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
                <h3 className="project-title">Stylos</h3>
                <a href="https://github.com/goktugkrblt/stylos" target="_blank" rel="noopener noreferrer" className="github-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
              </div>
              <p className="project-description">
                Stylos is a mini CSS-based game where players try to match a target radius by adjusting their shape, testing precision and timing in a simple, fun interface.
              </p>
              <div className="project-tags">
                <span className="tag">HTML / CSS</span>
                <span className="tag">JavaScript</span>
                <span className="tag">React</span>
              </div>
            </div>
          </div>
          </a>
          {/* Proje 4 */}
         <a href="https://countrilla.vercel.app/">
          <div className="project-card">
            <div className="project-image">
            <img src={countrillaImg} alt="Countrilla project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
                <div className="title-with-badge">
                  <h3 className="project-title">Countrilla</h3>                  
                </div>
                <a href="https://github.com/goktugkrblt/countrilla" target="_blank" rel="noopener noreferrer" className="github-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
              </div>
              <p className="project-description">
                Countrilla is an interactive React app where users type a country name and instantly see its flag, population, capital, and other details, providing a fun and informative geography experience.
              </p>
              <div className="project-tags">
                <span className="tag">React</span>
                <span className="tag">CSS / SCSS</span>
                <span className="tag">Axios</span>
              </div>
            </div>
          </div>
          </a> 

          {/* Proje 5 */}
          <a target='_blank' rel='noreferrer' href='https://veqsy.vercel.app/'>
          <div className="project-card">
            <div className="project-image">
            <img src={veqsyImg} alt="Veqsy project" className="project-img" />
            </div>
            <div className="project-info">
              <div className="project-header">
              <div className="title-with-badge">
                  <h3 className="project-title">Veqsy</h3>
                  <span className="beta-badge">BETA</span>
                </div>
                
                
              </div>
              <p className="project-description">
                Veqsy is a browser-based note-taking app that lets users write, download, and customize notes with various fonts and styles for a personalized experience.
              </p>
              <div className="project-tags">
                <span className="tag">SCSS</span>
                <span className="tag">JavaScript</span>
                <span className="tag">React</span>
              </div>
            </div>
          </div>
          </a>
        </div>
      </div>

      <style>{`
        .middle-section {
          width: 100%;
          min-height: 80vh;
          
          position: relative;
          padding: 120px 40px;
          overflow: hidden;
        }

        /* Arka plan dekorasyonları */
        .bg-decoration {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        .glow-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.15;
        }

        .glow-orb-1 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, #ffffff 0%, transparent 70%);
          top: 10%;
          left: 10%;
          animation: float 8s ease-in-out infinite;
        }

        .glow-orb-2 {
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, #888888 0%, transparent 70%);
          bottom: 20%;
          right: 15%;
          animation: float 10s ease-in-out infinite reverse;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(30px, -30px); }
        }

        .noise-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='3.5' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.05'/%3E%3C/svg%3E");
          opacity: 0.5;
        }

        /* İçerik */
        .content-wrapper {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          margin: 0 auto;
          margin-bottom: 100px;
        }

        /* Başlık */
        .section-header {
          margin-bottom: 80px;
        }

        .section-title {
          font-size: 36px;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 20px 0;
          letter-spacing: -0.02em;
        }

        .light .section-title{
            color: #333
        }

        .title-line {
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #ffffff, transparent);
        }

        .light .title-line{
            background: linear-gradient(to right, #333, transparent);
        }

        /* Projeler Grid */
        .projects-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 40px;
          align-items: stretch;
        }

        /* Proje Kartları */
        .project-card {
          background: #232323;
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.4s ease;
          cursor: pointer;
          height: 100%;
        }

        .light .project-card{
            border: 1px solid rgb(230 230 230);
            background: rgb(253 253 253);
        }
        .project-card:hover {
          background: rgba(255, 255, 255, 0.04);
          border-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-8px);
        }

        .light .project-card:hover{
            border: 1px solid rgb(230 230 230);
        }

        .project-image {
          width: 100%;
          height: 240px;
          overflow: hidden;
          background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
        }

        .project-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .project-card:hover .project-img {
          transform: scale(1.05);
        }

        .image-placeholder {
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          transition: transform 0.4s ease;
        }

        .project-card:hover .image-placeholder {
          transform: scale(1.05);
        }

        .placeholder-text {
          font-size: 72px;
          font-weight: 900;
          color: rgba(255, 255, 255, 0.05);
          letter-spacing: -0.05em;
        }

        .project-info {
          padding: 24px;
        }

        /* Proje Header (Title + GitHub) */
        .project-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
        }

        .title-with-badge {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .project-title {
          font-size: 24px;
          font-weight: 600;
          color: #ffffff;
          margin: 0;
          letter-spacing: -0.01em;
        }

        .light .project-title{
            color: #333;
        }

        /* Beta Badge */
        .beta-badge {
          font-size: 10px;
          font-weight: 700;
          color: #ffffff;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          padding: 4px 8px;
          border-radius: 4px;
          letter-spacing: 0.05em;
          transition: all 0.3s ease;
        }

        .project-card:hover .beta-badge {
          background: rgba(255, 255, 255, 0.15);
          border-color: rgba(255, 255, 255, 0.3);
        }

        /* GitHub Link */
        .github-link {
          color: #666666;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px;
          border-radius: 6px;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .github-link:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.05);
        }

        .github-link svg {
          display: block;
        }

        .project-description {
          font-size: 15px;
          color: #888888;
          line-height: 1.6;
          margin: 0 0 20px 0;
        }

        .project-tags {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .tag {
          font-size: 12px;
          color: #666666;
          padding: 6px 12px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 6px;
          transition: all 0.3s ease;
        }

        .light .tag{
            border: 1px solid rgb(145 145 145);
        }

        .project-card:hover .tag {
          color: #999999;
          background: rgba(255, 255, 255, 0.05);
        }

        /* Responsive */
        @media (max-width: 1068px) {
            .middle-section {
              padding: 80px 60px;
            }
      
          }
        @media (max-width: 734px) {
          .middle-section {
            padding: 80px 30px;
          }

          .section-title {
            font-size: 36px;
          }

          .projects-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
        }
        
      `}</style>
    </div>
  );
}

export default MiddleSection;